function numberWithDots(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

function calculateDiscount(price, compare_at_price_max) {
    if (!compare_at_price_max || compare_at_price_max <= price) {
        return "0%";
    }

    let discount = Math.ceil(((compare_at_price_max - price) * 100) / compare_at_price_max);
    return discount + "%";
}

function cancel_address_new() {
    $('#address-new').slideUp(300, function () {
        $(this).hide();
    });
    $('.add-new-address').show()
}

function add_new_address() {
    // console.log(".customer-address-table", $(".customer-address-table"))
    if (window.matchMedia("(max-width: 1024px)").matches) {
        $('html').addClass('disable-scroll')
        $('.site-header-container').addClass('background-cream')
    }

    $('#address-new').slideDown(300, function () {
        $(this).show();
    });
    $('.add-new-address').hide()
    $(".customer-address-table").hide()
    $('.account-page-address-empty').hide()
}

function edit_address(id) {
    // $(".customer-address-table").hide(); // Sembunyikan semua form edit
    if (window.matchMedia("(max-width: 1024px)").matches) {
        $('html').addClass('disable-scroll')
        $('.site-header-container').addClass('background-cream')
    }

    $('#edit_address_' + id).slideUp(300, function () {
        $(this).show();
        $('.add-new-address').hide();
    });
    $('.addresses').css('display', 'none');
}

function remove_edit_address(id) {
    $(".customer-address-table").hide(); // Sembunyikan semua form edit
    $('#edit_address_' + id).slideDown(300, function () {
        $(this).hide();
    });
    $('.add-new-address').show();
    $('.addresses').css('display', 'block');
}

function open_detail_order(id) {
    var awb = $('#awb-' + id).attr('data-id');
    // var awb = '0120852500006514';
    let jsonData = {
        awb: awb,
        url_shopify: Shopify.shop
    };

    var url = "https://atmos-custom-plugin-front.devbdd.com/api/customers/get_order_shipping";

    $.ajax({
        type: "POST",
        url: "https://atmos-custom-plugin-front.devbdd.com/api/customers/get_order_shipping",
        data: JSON.stringify({
            awb: awb,
            url_shopify: Shopify.shop
        }),
        contentType: "application/json",
        dataType: "json",
        success: function (response) {
            console.log(response); // Debugging to check structure

            // Step 1: Group data by date
            let groupedData = {};

            response.msg.forEach(item => {
                let [day, month, year, time] = item.date.match(/(\d{2})-(\d{2})-(\d{4}) (\d{2}:\d{2})/).slice(1);
                let formattedDate = `${day}-${month}-${year}`; // Key for grouping

                if (!groupedData[formattedDate]) {
                    groupedData[formattedDate] = [];
                }

                groupedData[formattedDate].push({
                    time: time,
                    desc: item.desc
                });
            });

            // Step 2: Append HTML
            let timelineContainer = $(".timeline");
            timelineContainer.empty(); // Clear existing content

            Object.keys(groupedData).forEach(dateKey => {
                let entriesHtml = groupedData[dateKey].map(entry => `
					<div class="entry">
						<span class="time">${entry.time}</span>
						<p>${entry.desc}</p>
					</div>
				`).join("");

                let timelineItemHtml = `
					<div class="timeline-item">
						<div class="date">${formatDateToDay(dateKey)}<br><span>${formatDateShortMonth(dateKey)}</span></div>
						<div class="line"></div>
						<div class="content">
							${entriesHtml}
						</div>
					</div>
				`;

                timelineContainer.append(timelineItemHtml);
            });
        },
        error: function (xhr, status, error) {
            console.log("Error:", error);
        }
    });

    $('.detail-summary').hide();
    $('.order-summary').removeClass('active')
    $(`#order-summary-${id}`).addClass('active')

    setTimeout(function () {
        var footerTop = $('#shopify-section-benefit-text-running').offset().top;
        var detailSummary = $('#detail-summary-' + id);
        var detailBottom = detailSummary.offset().top + detailSummary.outerHeight();
        $('#detail-summary-' + id).toggleClass('active').slideToggle(200);
        $('html').toggleClass('disable-scroll')

        if (!window.matchMedia("(max-width: 1024px)").matches) {
            if ($('#detail-summary-' + id).hasClass('active')) {
                if (detailBottom > footerTop) {
                    $('html, body').animate({
                        scrollTop: detailSummary.offset().top
                    }, 500);
                } else {
                    $('html, body').animate({
                        scrollTop: detailSummary.offset().top - 200
                    }, 500);
                }
            } else {
                $('#detail-summary-' + id).hide();
            }
        }

    }, 400);
}

function formatDateToDay(dateStr) {
    let [day, month, year] = dateStr.split("-");
    let dateObj = new Date(`${year}-${month}-${day}`);
    return dateObj.toLocaleDateString("en-US", { weekday: "long" });
}

function formatDateShortMonth(dateStr) {
    let [day, month, year] = dateStr.split('-');
    let date = new Date(`${year}-${month}-${day}`);
    return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
}

function formatRupiah(money) {
    return new Intl.NumberFormat('id-ID',
        { minimumFractionDigits: 0 } // diletakkan dalam object
    ).format(money);
}

(function ($) {
    $(document).ready(function () {
        const $annoucement_bar = $("#shopify-section-main-text-running");
        const $header = $(".site-header-container");
        const initialTop = $header.offset().top;

        $(window).on("scroll", function () {
            if ($(window).scrollTop() >= initialTop) {
                // $annoucement_bar.addClass("fixed");
                $header.addClass("fixed");
                $header.parent().addClass('is-fixed');

                if ($('#notify-sidebar').length) {
                    $('#notify-sidebar').css({ 'top': '68px' })
                }
            } else {
                // $annoucement_bar.removeClass("fixed");
                $header.removeClass("fixed");
                // $header.removeAttr("style");
                $header.parent().removeClass('is-fixed');

                if ($('#notify-sidebar').length) {
                    $('#notify-sidebar').removeAttr('style')
                }
            }
        });

        if ($(".main-text-running").length) {
            const text_running = new Swiper(".main-text-running", {
                loop: true,
                autoplay: {
                    delay: 1,
                    disableOnInteraction: false,
                },
                freeMode: true,
                speed: 14000,
                slidesPerView: 'auto',
                spaceBetween: 0,
                allowTouchMove: false,
                simulateTouch: false,
                keyboard: {
                    enabled: false,
                },
                mousewheel: {
                    enabled: false,
                }
            });
        }

        // header mega menu
        function setMegaMenuHeight() {
            let headerHeight = $(".site-header").outerHeight()
            $(".MegaMenu").each(function () {
                $(this).css({
                    'max-height': `calc(100vh - ${headerHeight}px)`
                })
            })
        }

        setMegaMenuHeight()
        $(window).resize(function () {
            setMegaMenuHeight()
        });

        if (!window.matchMedia("(max-width: 1024px)").matches) {

            const viewportWidth = $(window).width();

            $(".desktop-menu-item.with-megamenu").each(function (_, el) {

                const $item = $(el);
                const submenu = $item.find(".MegaMenu").first();
                if (!submenu.length) return;

                const pos = $item.position();

                let leftValue = 0;

                // =========================
                // > 1300px → LOGIC LAMA
                // =========================
                if (viewportWidth > 1300) {
                    leftValue = Math.round(-pos.left / 2);
                }

                // =========================
                // 1025px – 1300px → LOGIC FIX
                // =========================
                else {
                    const submenuWidth = submenu.outerWidth();

                    leftValue = Math.round(-pos.left);

                    // cek overflow kanan viewport
                    const submenuLeftInViewport =
                        submenu.offset().left + leftValue;

                    const overflowRight =
                        submenuLeftInViewport + submenuWidth - viewportWidth;

                    if (overflowRight > 0) {
                        leftValue -= Math.round(overflowRight);
                    }
                }

                submenu.css({
                    position: "absolute",
                    left: leftValue + "px"
                });
            });
        }

        $("#desktop-menu .desktop-menu-item").on("mouseenter", function () {
            $("body").css("overflow", "auto")
            $(".MegaMenu").removeClass("show--mega-menu")
            $('.body-overlay-megamenu').removeClass('is-visible')
            $("#desktop-menu .desktop-menu-item.active").each(function () {
                $(this).removeClass("active")
            })

            if ($(this).find(".MegaMenu").length) {
                $('.btn-cart-section-close').trigger('click')
                account_header_close('.accounts-section > a')
                account_popup_close('.accounts-section > a')
                $('#close-search-header-button').trigger('click')

                $(this).addClass("active")
                $(this).find(".MegaMenu").addClass("show--mega-menu")
                $('.body-overlay-megamenu').addClass('is-visible')
            }
        })

        $(".MegaMenu .has-megamenu-sub").on("mouseenter", function () {
            $(".MegaMenu-sub").removeClass("show--mega-menu-sub")
            $(".MegaMenu .has-megamenu-sub.active").each(function () {
                $(this).removeClass("active")
            })

            if ($(this).find(".MegaMenu-sub").length) {
                $(this).addClass("active")
                $(this).find(".MegaMenu-sub").addClass("show--mega-menu-sub")
            }
        })

        $('#site-header').on('mouseleave', function () {
            if ($(".show--mega-menu").length) {
                $("body").css("overflow", "auto")
                $(".MegaMenu").removeClass("show--mega-menu")
                $("#desktop-menu .desktop-menu-item.active").each(function () {
                    $(this).removeClass("active")
                })

                // $(".MegaMenu-sub").removeClass("show--mega-menu-sub")
                // $(".MegaMenu .has-megamenu-sub").each(function () {
                //     $(this).removeClass("active")
                // })
                $('.body-overlay-megamenu').removeClass('is-visible')
            }
        });
        // end header mega menu

        // cart header
        $(document).on('click', '.btn-cart', function () {
            $('.main-text-running').addClass('show--overlay')
            $('#site-header').trigger('mouseleave')
            account_header_close('.accounts-section > a')
            account_popup_close('.accounts-section > a')
            $('#close-search-header-button').trigger('click')

            if (!window.matchMedia("(max-width: 1024px)").matches) {
                $('.cart-header').addClass('show')
                $('.body-overlay-cart').addClass('is-visible')
            }
            else {
                if ($(this).hasClass('active')) {
                    $(this).find('.item-count-badge').removeAttr('style')
                    $(this).find('.item-close-badge').removeAttr('style')
                    $('.site-header-container').removeAttr('style')
                }
                else {
                    if ($('#new-main-nav-toggle').attr('aria-click') == 'true') {
                        $('#new-main-nav-toggle').trigger('click')
                    }

                    if ($('#notify-sidebar').attr('aria-sidebar') == 'opened') {
                        $('.close-notify').trigger('click')
                    }

                    $(this).find('.item-count-badge').css({ 'display': 'none' })
                    $(this).find('.item-close-badge').css({ 'display': 'inline-block' })
                    $('.site-header-container').css({ 'background-color': '#FFF8FC' })
                }

                $(this).toggleClass('active')
                $('#melissa-sidebar').attr('aria-sidebar', 'closed')
                $('.cart-header').toggleClass('show')
                $('.body-overlay-cart').toggleClass('is-visible')
            }

            setTimeout(function () {
                if (!window.matchMedia("(max-width: 1024px)").matches) {
                    $('.row-cart-header-product').addClass('active')
                }
                else {
                    $('#cart-header-filled').addClass('active')
                }
            }, 200)
        })

        $(document).on('click', '.btn-cart-section-close', function () {
            $('.row-cart-header-product').removeClass('active')

            setTimeout(function () {
                $("#shopify-section-main-text-running").removeAttr('style')
                if (window.matchMedia("(max-width: 1024px)").matches) {
                    $(".site-header-container").removeAttr('style')
                }

                $('.cart-header').removeClass('show')
                $('.main-text-running').removeClass('show--overlay')
                $('.body-overlay-cart').removeClass('is-visible')

            }, 200);
        })

        renderCartHeader();
        function renderCartHeader() {
            let product_line_item_str = '<article class="cart-product-item"><div class="cart-product-image"><img src="" alt=""></div><div class="cart-product-center"><div class="cart-product-title-color"><div class="cart-product-title"><a href="" class="title"></a><span class="cart-product-status-badge"></span></div><div class="cart-product-color"><div class="color"></div></div></div><div class="cart-product-size"><div class="cart-product-size-label"><div class="label">Size:</div></div><div class="cart-product-size-value"><div class="value"></div></div></div><div class="cart-center-blank show-for-large"></div><div class="cart-center-qty-price hide-for-large"><div class="cart-product-qty"><div class="cart-product-qty-label"><div class="label">Quantity:</div></div><div class="cart-product-qty-value"><button class="cart-product-qty-min" id="cart-product-qty-min">-</button><div class="value"></div><button class="cart-product-qty-plus" id="cart-product-qty-plus">+</button></div></div></div></div><div class="cart-product-right show-for-large"><div class="cart-product-price"><div class="price"></div></div><div class="cart-product-qty"><div class="cart-product-qty-label"><div class="label">Quantity:</div></div><div class="cart-product-qty-value"><button class="cart-product-qty-min" id="cart-product-qty-min">-</button><div class="value"></div><button class="cart-product-qty-plus" id="cart-product-qty-plus">+</button></div></div><div class="cart-product-remove"><button class="btn-cart-remove" data-id="">Remove</button></div></div></article>'
            let product_line_item = jQuery(product_line_item_str)
            let total = 0

            $.ajax({
                type: 'GET',
                url: '/cart.js',
                cache: false,
                dataType: 'json',
                success: function (cart) {
                    $('.btn-cart .item-count-badge').html(cart.item_count)
                    $('.cart-section-header-text .item-count-badge').html(cart.item_count)
                    $('.cart-header-summary-label .label').html(`Items (${cart.item_count})`)

                    if (cart.item_count != 0) {
                        $('#cart-header-filled').show()
                        $('#cart-header-empty').hide()
                        $('#cart-product-list').html('')

                        jQuery.each(cart.items, function (i, v) {
                            let temp = product_line_item.clone();
                            let final_price = '' + v.final_price;
                            final_price = final_price.substring(0, final_price.length - 2);
                            final_price = final_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

                            $.ajax({
                                type: 'GET',
                                url: `/variants/${v.variant_id}.js`,
                                cache: false,
                                dataType: 'json',
                                success: function (variant) {
                                    if (variant.inventory_quantity == 1) {
                                        temp.find('.cart-product-status-badge').html('1 Item left!')
                                    }
                                }
                            })

                            temp.find('.cart-product-image img').prop('src', v.featured_image.url);
                            temp.find('.cart-product-image img').prop('alt', v.featured_image.alt);
                            temp.find('.cart-product-title .title').prop('href', v.url);
                            temp.find('.cart-product-title .title').html(v.product_title.toLowerCase());
                            temp.find('.cart-product-price .price').html('IDR ' + final_price);
                            temp.find('.cart-product-size-value .value').html(v.options_with_values[0].value);
                            temp.find('.cart-product-color .color').html(v.options_with_values[1].value.toLowerCase());
                            temp.find('.cart-product-qty-value .value').html(v.quantity);
                            temp.find('.cart-product-remove .btn-cart-remove').attr('data-id', v.key);
                            temp.find('.cart-product-qty-min').attr('data-id', v.key);
                            temp.find('.cart-product-qty-min').attr('data-qty', v.quantity);
                            temp.find('.cart-product-qty-plus').attr('data-id', v.key);
                            temp.find('.cart-product-qty-plus').attr('data-qty', v.quantity);

                            total += v.final_price;

                            // console.log('cart', cart)

                            jQuery('#cart-product-list').append(temp);

                            if (!window.matchMedia("(max-width: 1024px)").matches) {
                                if (cart.items.length > 2) {
                                    $('.cart-header').addClass('cart-header-count-3')
                                }
                                else {
                                    $('.cart-header').removeClass('cart-header-count-3')
                                }
                            }
                        });

                        let final_total = '' + total;
                        final_total = final_total.substring(0, final_total.length - 2);
                        final_total = final_total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

                        $('.cart-header-summary-value .value').html('IDR ' + final_total)
                        $('.cart-header-total-value .value').html('IDR ' + final_total)
                    }
                    else {
                        $('#cart-header-empty').show()
                        $('#cart-header-filled').hide()
                    }
                }
            });
        }

        $(document).on('click', '.btn-cart-remove', function () {
            // console.log('btn-cart-remove clicked')
            let line_id = $(this).attr('data-id')

            $.ajax({
                type: 'POST',
                url: '/cart/change.js',
                data: {
                    'id': line_id,
                    'quantity': 0
                },
                cache: false,
                dataType: 'json',
                success: function () {
                    renderCartHeader()
                }
            })
        })

        $(document).on('click', '.cart-product-qty-min', function () {
            // console.log('cart-product-qty-min clicked')
            let line_id = $(this).attr('data-id')
            let qty = parseInt($(this).attr('data-qty'))

            $.ajax({
                type: 'POST',
                url: '/cart/change.js',
                data: {
                    'id': `${line_id}`,
                    'quantity': qty - 1
                },
                cache: false,
                dataType: 'json',
                success: function () {
                    renderCartHeader()
                }
            })
        })

        $(document).on('click', '.cart-product-qty-plus', function () {
            // console.log('cart-product-qty-plus clicked')
            let line_id = $(this).attr('data-id')
            let qty = parseInt($(this).attr('data-qty'))

            $.ajax({
                type: 'POST',
                url: '/cart/change.js',
                data: {
                    'id': `${line_id}`,
                    'quantity': qty + 1
                },
                cache: false,
                dataType: 'json',
                success: function () {
                    renderCartHeader()
                }
            })
        })

        $(document).on('click', '#addToCart', function () {
            // console.log('#addToCart clicked')
            setTimeout(function () {
                renderCartHeader()
                cartNotifShow()
            }, 1000)
        })

        // sidebar notify
        $(document).on('click', '.btn-product-notify', function () {
            $('html').addClass('disable-scroll');
            $('#new-main-nav-toggle').hide();
            $('#search-sidebar-button').hide();
            if (window.matchMedia("(max-width: 1024px)").matches) {
                if ($(".site-header-container").hasClass('fixed')) {
                    $('#notify-sidebar').css({ 'top': '68px' })
                }
                else {
                    $('#notify-sidebar').removeAttr('style')
                }
            }

            $('.site-header-container').css({ 'background-color': '#FFF8FC' })
            $('.body-overlay-notify').addClass('is-visible')
            $('.header-notify-close').show()
            $('#notify-sidebar').attr('aria-sidebar', 'opened')
        })

        $(document).on('click', '.close-notify', function () {
            $('html').removeClass('disable-scroll');

            $('#new-main-nav-toggle').show();
            $('#search-sidebar-button').show();

            $('.site-header-container').css({ 'background-color': '#FFF' });
            $('.body-overlay-notify').removeClass('is-visible')
            $('.header-notify-close').hide()

            $(".group-before-submit").show();
            $(".group-after-submit").hide();

            $('#notify-sidebar').attr('aria-sidebar', 'closed')
            $('#notify-sidebar form input').val('');
        })

        $(document).on('click', '.body-overlay-notify', function () {
            $('.close-notify').trigger('click')
        })

        $(document).on('change', '.form-notify .form-notify-input', function () {
            is_notify_true = false
            $('.form-notify .form-notify-input').each(function (i, v) {
                if ($(v).hasClass('input-agreement')) {
                    is_notify_true = $(v).is(':checked')
                }
                else {
                    is_notify_true = $(v).val().length > 0
                }

                if (!is_notify_true) {
                    return false;
                }
            })

            if (is_notify_true) {
                $('.form-notify-submit').removeAttr('disabled')
            }
            else {
                $('.form-notify-submit').attr('disabled', 'true')
            }
        })

        $(document).on("submit", "#notify-sidebar form", function (e) {
            e.preventDefault();
            var url =
                "https://notify-general.shopify-plugin.devbdd.com/config/simpanCustomer";
            const formData = new FormData(this);
            formData.append("url_shopify", Shopify.shop);

            $.ajax({
                type: "POST",
                url: url,
                data: formData,
                dataType: "text",
                cache: false,
                contentType: false,
                crossDomain: true,
                processData: false,
                beforeSend: function () {
                    $(".form-notify-submit").text("Pleas Wait...");
                    $(".form-notify-submit").attr(
                        "disabled",
                        "disabled"
                    );
                },
                success: function (response) {
                    $(".form-notify-submit").text("Submit");
                    $(".form-notify-submit").attr("disabled", false);

                    if (response == 200) {
                        $(".group-before-submit").hide();
                        $(".group-after-submit").show();
                        // $(".info-message").html(`You'll be notified when this item is back in stock!`);
                        $('#notify-sidebar').attr('aria-sidebar', 'closed')
                        $('.body-overlay-notify').removeClass('is-visible')
                        $('.header-notify-close').hide()

                        if (!window.matchMedia("(max-width: 1024px)").matches) {
                            $('.body-overlay-product-recommendation').addClass('is-visible')
                        }
                        $('#product_recommendation_modal').show()
                        $('.header-product_recommendation-close').show()

                    } else {
                        // $(".info-message").html("Something wrong, try again.");
                        let res = JSON.parse(response);
                        $(".info-message").html('message: ' + res.message)
                        // setTimeout(function () {
                        //     location.reload();
                        // }, 1000);
                    }
                },
                error: function (response) {
                    alert("Something wrong, Please refresh page.");
                },
            });
        });

        $(document).on('click', '.close-product_recommendation_modal', function () {
            $('html').removeClass('disable-scroll');
            $('.site-header-container').css({ 'background-color': '#FFF' });
            $('.body-overlay-product-recommendation').removeClass('is-visible')

            $('#new-main-nav-toggle').show();
            $('#search-sidebar-button').show();
            $('.header-product_recommendation-close').hide()
            $('#product_recommendation_modal').hide()
        })

        $('#product_recommendation_modal').click(function (e) {
            if (e.target == this) {
                $('.close-product_recommendation_modal').trigger('click')
            }
        })
        // end sidebar notify

        $(document).on('click', '.body-overlay-cart', function () {

            if (!window.matchMedia("(max-width: 1024px)").matches) {
                $('.btn-cart-section-close').trigger('click')
            }
            else {
                // $(document).on('click', '.btn-cart', function () {})
                $('.btn-cart').trigger('click')

            }
        })
        // end cart header

        // account header
        function account_header_close(self) {
            $(self).removeClass('active')
            $('.account-header').removeClass('show')
            $(".site-header-container").removeAttr('style')
            $("#shopify-section-main-text-running").removeAttr('style')
            $('.body-overlay-account').removeClass('is-visible')

            // console.log('$(window).scrollTop()', $(window).scrollTop())
            // console.log(`$(".site-header-container").offset().top`, $(".site-header-container").offset().top)

            if ($(window).scrollTop() == 0) {
                $(".site-header-container").removeClass("fixed");
                $("#shopify-section-main-text-running").removeClass("fixed");
            }
        }

        function account_popup_close(self) {
            $(self).removeClass('active')
            $('.account-popup').removeClass('show--popup')
            $(".site-header-container").removeAttr('style')
            $('.body-overlay-account-popup').removeClass('is-visible')

            // if ($(window).scrollTop() < $(".site-header-container").offset().top) {
            //     $(".site-header-container").removeClass("fixed");
            // }
        }

        $(document).on('click', '.accounts-section > a', function (e) {
            let isLogin = $(this).attr('data-is-login')
            if (isLogin == 'true') {
                return;
            }

            e.preventDefault()
            if (!$(this).hasClass('active')) {
                $('#site-header').trigger('mouseleave')
                $('.btn-cart-section-close').trigger('click')
                $('#close-search-header-button').trigger('click')

                $(this).addClass('active')
                $('.account-popup').addClass('show--popup')
                $('.body-overlay-account-popup').addClass('is-visible')

                $('#search-section-button').show()
                $('.search-header').removeClass('show')
                $('.cart-header').removeClass('show')
            }
            else {
                account_popup_close(this)
                account_header_close(this)
            }
        })

        $(document).on('click', '.body-overlay-account-popup', function () {
            account_popup_close('.accounts-section > a')
        })

        $('#account-popup-login').click(function () {
            $('#site-header').trigger('mouseleave')
            $('.btn-cart-section-close').trigger('click')
            $('#close-search-header-button').trigger('click')
            account_popup_close(this)

            setTimeout(function () {
                $("#shopify-section-main-text-running").addClass('fixed')
                $(".site-header-container").addClass('fixed')
                $('.account-header').addClass('show')
                $('.body-overlay-account').addClass('is-visible')

                $("#shopify-section-main-text-running").css({ 'background-color': '#FFF8FC' })
                $(".site-header-container").css({ 'background-color': '#FFF8FC' })
            }, 500)
        })

        $(document).on('click', '.body-overlay-account', function () {
            account_header_close('.accounts-section > a')
        })
        // end account header

        // search header
        $('#search-section-button').click(function () {
            // if ($('body').hasClass('template-search')) {
            //     return;
            // }
            $('#site-header').trigger('mouseleave')
            account_header_close('.accounts-section > a')
            account_popup_close('.accounts-section > a')
            $('.btn-cart-section-close').trigger('click')

            setTimeout(function () {
                $('#search-section-button').hide()
                $(".site-header-container").addClass('fixed')
                $('.search-header').addClass('show')
                $('#search-box').focus()
                $('.body-overlay-search').addClass('is-visible')

                $("#shopify-section-main-text-running").css({ 'background-color': '#FFF8FC' })
                $(".site-header-container").css({ 'background-color': '#FFF8FC' })
            }, 500)

        })

        $('#close-search-header-button').click(function () {
            $(".site-header-container").removeAttr('style')
            $('.search-header').removeClass('show')
            $('.body-overlay-search').removeClass('is-visible')

            if ($(window).scrollTop() == 0) {
                $(".site-header-container").removeClass("fixed");
                $("#shopify-section-main-text-running").removeClass("fixed");
            }

            $('#search-section-button').show()
            $('.search-top').removeClass('active')
            $("#search-results").hide()
            $('#search-box').val('')

        })

        $(document).on('click', '.body-overlay-search', function () {
            $('#close-search-header-button').trigger('click')
        })

        function searchRedirect() {
            let query = encodeURIComponent($(this).val().trim());
            if (query) {
                location.href = `/search?type=product&q=${query}`
            }
        }

        $('.search-box').on('keydown', function (e) {
            if (e.key == 'Enter') {
                searchRedirect()
            }
        })

        $('.search-header-button').click(function () {
            searchRedirect()
        })

        // end search header

        // cart notif
        function cartNotifShow() {
            let product_line_item_str = '<article class="cart-product-item"><div class="cart-product-image"><img src="" alt=""></div><div class="cart-product-center"><div class="cart-product-title-color"><div class="cart-product-title"><a href="" class="title"></a></div><div class="cart-product-color"><div class="color"></div></div></div><div class="cart-product-size"><div class="cart-product-size-label"><div class="label">Size:</div></div><div class="cart-product-size-value"><div class="value"></div></div></div></div></article>'
            let product_line_item = jQuery(product_line_item_str)
            $('#cart-notif-products').html('')

            $.ajax({
                type: 'GET',
                url: '/cart.js',
                cache: false,
                dataType: 'json',
                success: function (cart) {
                    if (cart.items && cart.items.length > 0) {
                        let temp = product_line_item
                        let lastItem = cart.items[0];

                        temp.find('.cart-product-image img').prop('src', lastItem.featured_image.url);
                        temp.find('.cart-product-image img').prop('alt', lastItem.featured_image.alt);
                        temp.find('.cart-product-title .title').prop('href', lastItem.url);
                        temp.find('.cart-product-title .title').html(lastItem.product_title.toLowerCase());
                        temp.find('.cart-product-size-value .value').html(lastItem.options_with_values[0].value);
                        temp.find('.cart-product-color .color').html(lastItem.options_with_values[1].value.toLowerCase());

                        $('#cart-notif-products').append(temp)

                        $('section.cart-section').addClass('active')
                        $('.cart-notif').addClass('show--popup')
                        $('.body-overlay-added-cart').addClass('is-visible')
                    }
                }
            })
        }

        if (window.matchMedia("(max-width: 1024px)").matches) {
            $('.cart-notif').click(function (event) {
                if (event.target === event.currentTarget) {
                    $('#cart-notif-continue').trigger('click');
                }
            })
        }

        $(document).on('click', '.cart-notif-continue', function () {
            $('section.cart-section').removeClass('active')
            $('.cart-notif').removeClass('show--popup')
            $('.body-overlay-added-cart').removeClass('is-visible')
        })

        $(document).on('click', '.cart-notif-view', function () {
            $('section.cart-section').removeClass('active')
            $('.cart-notif').removeClass('show--popup')
            $('.body-overlay-added-cart').removeClass('is-visible')
            $('.btn-cart').trigger('click')
        })
        // end cart notif

        // sidebar
        $(document).on('click', '.sidebar-collapsible-bottom .sidebar-collapsible--link[data-menu="account"]', function (e) {
            e.preventDefault()

            if ($(this).attr('data-is-login') == 'false') {
                $('#new-main-nav-toggle').attr('aria-click', 'false');
                $('#melissa-sidebar').attr('aria-sidebar', 'closed')
                $('.account-header').addClass('show')
                $('section.cart-section').hide()
                $('.account-header-close').show()
            }
            else {
                location.href = $(this).attr('href')
            }
        })

        $(document).on('click', '.account-header-close', function () {
            $('.account-header').removeClass('show')
            $('section.cart-section').show()
            $('.account-header-close').hide()
        })
        // end sidebar

        if ($('.catalog-product-slider').length) {
            if (window.matchMedia("(max-width: 1024px)").matches) {
                const catalog_product = new Swiper('.catalog-product-slider', {
                    slidesPerView: 'auto',
                    spaceBetween: 22,
                    slidesPerGroup: 3,
                    slidesPerGroupAuto: true,
                    scrollbar: {
                        el: '.catalog-product-slider .swiper-scrollbar',
                        draggable: true,
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                });
            }
        }

        if ($('.home-banner').length) {
            const home_banner_slider = new Swiper(".home-banner-slider", {
                loop: true,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                freeMode: false,
                speed: 500,
                slidesPerView: 1,
                spaceBetween: 0,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                    renderBullet: function (index, className) {
                        return `
                        <div class="${className}">
                            <div class="pagination-progress"></div>
                        </div>`;
                    },
                },
                on: {
                    init: function () {
                        const bullets = document.querySelectorAll('.home-banner-slider .swiper-pagination .swiper-pagination-bullet');
                        bullets.forEach(bullet => {
                            bullet.classList.remove('swiper-pagination-bullet-active');
                        });
                    }
                }
            });

            home_banner_slider.on('slideChange', function () {
                $('.home-banner-slider .pagination-numbers .page-number').html(`<span>${home_banner_slider.realIndex + 1}</span>`)
            });

            // var vids = $('.home-banner video');
            // $.each(vids, function () {
            //     this.controls = false;
            //     this.autoplay = true;
            // });

            // const video = document.querySelector('.home-banner video');
            // video.muted = true;
            // video.playsInline = true;
            // video.loop = true;
            // video.play().catch(e => console.log("Autoplay prevented:", e));
        }

        if ($(".collection-product-swiper").length) {
            const collection_product_swiper = new Swiper(".collection-product-swiper", {
                loop: true,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                freeMode: false,
                speed: 500,
                slidesPerView: 1,
                spaceBetween: 0,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                    renderBullet: function (index, className) {
                        return `
                        <div class="${className}">
                            <div class="pagination-progress"></div>
                        </div>`;
                    },
                },
                on: {
                    init: function () {
                        const bullets = document.querySelectorAll('.collection-product-swiper .swiper-pagination .swiper-pagination-bullet');
                        bullets.forEach(bullet => {
                            bullet.classList.remove('swiper-pagination-bullet-active');
                        });
                    }
                }
            });

            collection_product_swiper.on('slideChange', function () {
                $('.collection-product-swiper .pagination-numbers .page-number').html(`<span>${collection_product_swiper.realIndex + 1}</span>`)
            });
        }

        function getDistanceFromBottom(next) {
            var rect = next[0].getBoundingClientRect();
            // console.log('rect.top', rect.top, 'window.innerHeight', window.innerHeight)
            if (rect.top >= 0 && rect.top <= (window.innerHeight || document.documentElement.clientHeight)) {
                return window.innerHeight - rect.top;
            }
            return null;
        }

        if ($('.parallax-gsap').length) {
            let image = $('.parallax-gsap').attr('data-image')
            let image_mobile = $('.parallax-gsap').attr('data-image-mobile')
            let is_mobile = $('.parallax-gsap').attr('data-is-mobile')

            if (window.matchMedia("(max-width: 1024px)").matches) {
                if (is_mobile == 'true') {
                    $('.parallax-gsap').css({ 'background-image': `url(${image_mobile})` })
                }
                else {
                    $('.parallax-gsap').css({ 'background-image': `url(${image})` })
                }
            }
            else {
                $('.parallax-gsap').css({ 'background-image': `url(${image})` })
            }

            $(window).on("scroll", function () {
                let sectionNext = $(".parallax-gsap").closest('.shopify-section').next()
                let scrollHeight = 0
                let distanceFromBottom = getDistanceFromBottom(sectionNext)
                // console.log('distanceFromBottom', distanceFromBottom)
                // let headerHeight = $(".site-header-container").outerHeight()
                let parallaxHeight = $(".parallax-gsap").outerHeight()
                let windowClientHeight = (window.innerHeight || document.documentElement.clientHeight)

                windowClientHeight = windowClientHeight - parallaxHeight
                // console.log('windowClientHeight', windowClientHeight)
                let distance = distanceFromBottom - windowClientHeight
                // console.log('distance', distance)


                if (distance !== null) {
                    if (distance >= 0) {
                        scrollHeight = distance
                    }
                }
                else {
                    scrollHeight = 0
                }

                if (!window.matchMedia("(max-width: 1024px)").matches) {
                    if (distance >= 0) {
                        $('.parallax-gsap').find('.parallax-gsap-block').css({ 'bottom': scrollHeight })
                    }
                }
            });
        }

        if ($('.parallax-video').length) {
            $(window).on("scroll", function () {
                let sectionNext = $(".parallax-video").closest('.shopify-section').next()
                let scrollHeight = 0
                let distanceFromBottom = getDistanceFromBottom(sectionNext)
                let parallaxHeight = $(".parallax-video").outerHeight()
                let windowClientHeight = (window.innerHeight || document.documentElement.clientHeight)

                windowClientHeight = windowClientHeight - parallaxHeight
                let distance = distanceFromBottom - windowClientHeight

                // console.log('parallaxHeight', parallaxHeight)
                // console.log('distanceFromBottom', distanceFromBottom)
                // console.log('windowClientHeight', windowClientHeight)
                // console.log('distance', distance)

                if (distance !== null) {
                    if (distance >= 0) {
                        scrollHeight = distance
                    }
                }
                else {
                    scrollHeight = 0
                }

                if (!window.matchMedia("(max-width: 1024px)").matches) {
                    if (distance >= 0) {
                        $('.parallax-video').find('.parallax-video-content').css({ 'bottom': scrollHeight })
                    }
                }
            });
        }

        if ($('.parallax-banner').length) {
            const parallax_banner_slider = new Swiper(".parallax-banner-slider", {
                loop: true,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                freeMode: false,
                speed: 500,
                slidesPerView: 1,
                spaceBetween: 0,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                    renderBullet: function (index, className) {
                        return `
                        <div class="${className}">
                            <div class="pagination-progress"></div>
                        </div>`;
                    },
                },
                on: {
                    init: function () {
                        const bullets = document.querySelectorAll('.parallax-banner-slider .swiper-pagination .swiper-pagination-bullet');
                        bullets.forEach(bullet => {
                            bullet.classList.remove('swiper-pagination-bullet-active');
                        });
                    }
                }
            });

            parallax_banner_slider.on('slideChange', function () {
                $('.parallax-banner-slider .pagination-numbers .page-number').html(`<span>${parallax_banner_slider.realIndex + 1}</span>`)
            });

            // var vids = $('.parallax-banner video');
            // $.each(vids, function () {
            //     this.controls = false;
            //     this.autoplay = true;
            // });

            // const video = document.querySelector('.parallax-banner video');
            // video.muted = true;
            // video.playsInline = true;
            // video.loop = true;
            // video.play().catch(e => console.log("Autoplay prevented:", e));

            $(window).on("scroll", function () {
                let sectionNext = $(".parallax-banner").closest('.shopify-section').next()
                let scrollHeight = 0
                let distanceFromBottom = getDistanceFromBottom(sectionNext)
                let parallaxHeight = $(".parallax-banner").outerHeight()
                let windowClientHeight = (window.innerHeight || document.documentElement.clientHeight)

                windowClientHeight = windowClientHeight - parallaxHeight
                let distance = distanceFromBottom - windowClientHeight

                // console.log('parallaxHeight', parallaxHeight)
                // console.log('distanceFromBottom', distanceFromBottom)
                // console.log('windowClientHeight', windowClientHeight)
                // console.log('distance', distance)

                if (distance !== null) {
                    if (distance >= 0) {
                        scrollHeight = distance
                    }
                }
                else {
                    scrollHeight = 0
                }

                if (!window.matchMedia("(max-width: 1024px)").matches) {
                    if (distance >= 0) {
                        $('.parallax-banner').find('.parallax-banner-bottom').css({ 'bottom': scrollHeight })
                        $('.parallax-banner').find('.pagination-numbers').css({ 'bottom': scrollHeight })
                    }
                }
            });
        }

        if ($(".benefit-text-running").length) {
            const text_running = new Swiper(".benefit-running-block", {
                loop: true,
                autoplay: {
                    delay: 1,
                    disableOnInteraction: false,
                },
                freeMode: true,
                speed: 8000,
                slidesPerView: 'auto',
                spaceBetween: 0,
            });
        }

        if ($('.three-home-banner').length) {
            if (window.matchMedia("(max-width: 1024px)").matches) {
                const three_banner = new Swiper('.three-banner-slider', {
                    slidesPerView: 'auto',
                    autoplay: {
                        delay: 2000,
                        disableOnInteraction: false,
                    },
                    spaceBetween: 15.8,
                    speed: 2000,
                    freeMode: true,
                    scrollbar: {
                        el: '.three-banner-slider .swiper-scrollbar',
                        draggable: true,
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                });
            }
        }

        // if ($('#insta-feed').length) {
        //     setTimeout(() => {
        //         $('#insta-feed h2').html('You. Us. Melissa. Let’s connect! #MelissaSquads')
        //     }, 3000)
        // }

        function setProductGrid() {
            let params = new URLSearchParams(window.location.search)
            if (window.matchMedia("(max-width: 1024px)").matches) {
                if (!params.has('product-grid')) {
                    params.set('product-grid', 2)
                    location.href = window.location.protocol + "//" + window.location.host + window.location.pathname + "?" + params.toString()
                }
                else {
                    let product_grid = params.get('product-grid')

                    $('.grid-view-item').removeClass('active')
                    $(`.grid-view-item-${product_grid}`).addClass('active')

                    $('.columns-products').removeClass('small-up-2')
                    $('.columns-products').removeClass('small-up-1')

                    $('.columns-products').addClass(`small-up-${product_grid}`)
                }
            }
            else {
                if (params.has('product-grid')) {
                    let product_grid = params.get('product-grid')
                    $('.grid-view-item').removeClass('active')
                    $(`.grid-view-item-${product_grid}`).addClass('active')

                    $('.columns-products').removeClass('medium-up-5')
                    $('.columns-products').removeClass('medium-up-4')
                    $('.columns-products').removeClass('medium-up-3')

                    $('.columns-products').addClass(`medium-up-${product_grid}`)

                    setTimeout(function () {
                        $('.column-banner-grid-odd').each(function (i, v) {
                            let height = $(v).prev().find('.product-list-item-2025').outerHeight()
                            $(v).find('.banner-list-image img').css({ 'max-height': `${height}px` })
                        })

                        $('.column-banner-grid-even').each(function (i, v) {
                            let height = $(v).next().find('.product-list-item-2025').outerHeight()
                            $(v).find('.banner-list-image img').css({ 'max-height': `${height}px` })
                        })
                    }, 300)
                }
            }
        }

        if ($('body').hasClass('template-collection')) {
            if ($('header.collection-header').hasClass('collection-has-image')) {
                $(".site-header-container").addClass('header-collection-image')
            }

            setProductGrid()
        }

        $('.collection .grid-view-toggle').click(function () {
            $(this).closest('.grid-view-container').toggleClass('active')
        })

        if ($('body').hasClass('template-product')) {
            const $navSlider = $('.product-image-slider-nav');
            const $mainSlider = $('.product-image-slider');
            const totalSlides = $navSlider.find('img').length;
            const totalMainSlides = $mainSlider.find('img').length;

            // Function to initialize the main slider
            const initializeMainSlider = () => {
                $mainSlider.slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    infinite: true,
                    fade: true,
                    asNavFor: '.product-image-slider-nav'
                });
            };

            // Function to initialize the navigation slider
            const initializeNavSlider = () => {
                $navSlider.slick({
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    vertical: true,
                    dots: false,
                    focusOnSelect: true,
                    verticalSwiping: false,
                    arrows: false,
                    asNavFor: '.product-image-slider',
                    infinite: true
                });
            };

            // Initialize both sliders initially
            initializeMainSlider();
            initializeNavSlider();

            // Clone slides if fewer than slidesToShow
            if (totalSlides <= 4) {
                const $slides = $navSlider.find('.slick-slide');
                const clonesNeeded = 8 - totalSlides;

                for (let i = 0; i < clonesNeeded; i++) {
                    const $clone = $slides.eq(i % totalSlides).clone(); // Clone from index 0
                    $navSlider.slick('slickAdd', $clone);
                }
            }

            if (totalMainSlides <= 4) {
                const $slides = $mainSlider.find('.slick-slide');
                const clonesNeeded = 8 - totalMainSlides;

                for (let i = 0; i < clonesNeeded; i++) {
                    const $clone = $slides.eq(i % totalMainSlides).clone(); // Clone from index 0
                    $mainSlider.slick('slickAdd', $clone);
                }
            }

            // Destroy and reinitialize both sliders to reflect changes
            $mainSlider.slick('unslick');
            $navSlider.slick('unslick');

            // Reinitialize sliders
            initializeMainSlider();
            initializeNavSlider();

            // Reinitialize position
            $(window).on('load', function () {
                $mainSlider.slick('setPosition');
                $navSlider.slick('setPosition');
            });

            //swatch-header-run
            if ($('.swatch-header-run').length) {
                let i = $('.swatch-header-run').attr('data-run')
                let min = 1;
                let max = 10;
                let range = max - min;
                let percentage = ((i - min) / range) * 95;
                percentage = percentage.toFixed(2) + "%";

                $('.swatch-header-run').find('.swatch-popup-slider-thumb').css({ 'left': percentage })
            }
            //end swatch-header-run

            let swiperIsEnd = false
            const new_product_images = new Swiper(".new-product-images", {
                direction: "vertical",
                freeMode: false,
                speed: 500,
                slidesPerView: 'auto',
                spaceBetween: 1,
                resistanceRatio: 0,
                on: {
                    touchEnd: function () {
                        const threshold = 10;
                        const isNextAttempt = this.touches.diff < -threshold;
                        const isPrevAttempt = this.touches.diff > threshold;

                        // console.log('isPrevAttempt', isPrevAttempt)
                        // console.log('before touchEnd', swiperIsEnd)
                        if (isPrevAttempt) {
                            swiperIsEnd = false;
                        }
                        // console.log('before touchEnd', swiperIsEnd)

                        // console.log('before touchEnd', swiperIsEnd)
                        if (swiperIsEnd) {
                            handleDragEnd(null, !productInfo.addClass("element-open"));
                        }
                        // console.log('after touchEnd', swiperIsEnd)

                        if (this.isEnd && !isPrevAttempt) {
                            swiperIsEnd = true;
                        }
                    }
                }
            });

            const swiperContainer = document.querySelector('.new-product-images');
            let swiperStartX = 0, swiperStartY = 0;

            // Handler untuk touch devices
            swiperContainer.addEventListener('touchstart', (e) => {
                swiperStartX = e.touches[0].clientX;
                swiperStartY = e.touches[0].clientY;
            });

            swiperContainer.addEventListener('touchend', (e) => {
                const deltaX = e.changedTouches[0].clientX - swiperStartX;
                const deltaY = e.changedTouches[0].clientY - swiperStartY;
                const threshold = 50;

                // Handle swipe vertikal
                if (Math.abs(deltaY) > Math.abs(deltaX)) {
                    return;
                }

                // Handle swipe horizontal
                if (deltaX > threshold && !new_product_images.isBeginning) {
                    new_product_images.slidePrev();
                    swiperIsEnd = false;
                } else if (deltaX < -threshold && !new_product_images.isEnd) {
                    new_product_images.slideNext();
                }
            });

            const productInfo = $('.template-product .column-product-form');
            const DRAG_THRESHOLD = 20; // Threshold untuk menentukan scroll dalam element
            const ANIMATION_DURATION = 500; // ms
            const HEIGHT_OFFSET = 326.3; // Nilai ini mungkin perlu disesuaikan
            const RECOMMENDATIONS_DELAY = 2000; // Delay untuk loading rekomendasi

            let isDragging = false;
            let startY = 0;

            // Variabel untuk track state
            let isProductInfoOpen = false;

            // Fungsi untuk clone dan atur section footer
            function setupMobileSections() {
                const sections = [
                    { id: 'shopify-section-footer-top', classAdd: 'shopify-section-footer-top-mobile' },
                    { id: 'shopify-section-footer-2025', classAdd: 'shopify-section-footer-2025-mobile' }
                ];

                sections.forEach(section => {
                    $(`#${section.id}`).toggleClass('show-for-large');
                    const clone = $(`#${section.id}`).clone().appendTo(productInfo);
                    clone.addClass(`${section.classAdd} hide-for-large`).removeClass('show-for-large');
                });

                // Setup product recommendations dengan delay
                // setTimeout(setupProductRecommendations, RECOMMENDATIONS_DELAY);
                setTimeout(setupProductRecentViewed, RECOMMENDATIONS_DELAY);
            }

            // function setupProductRecommendations() {
            //     const recSection = $('#shopify-section-product-recommendations');
            //     recSection.toggleClass('show-for-large');

            //     const clone = recSection.clone().insertBefore('.shopify-section-footer-top-mobile');
            //     clone.addClass('shopify-section-product-recommendations-mobile hide-for-large')
            //         .removeClass('show-for-large');
            // }

            function setupProductRecentViewed() {
                const viewSection = $('#shopify-section-recently-view-products');
                // viewSection.toggleClass('show-for-large');
                viewSection.remove();

                const clone = viewSection.clone().insertBefore('.shopify-section-footer-top-mobile');
                clone.addClass('shopify-section-product-recommendations-mobile hide-for-large')
                // .removeClass('show-for-large');

                setProductRecentViewToSlider();
            }

            function setProductRecentViewToSlider() {
                // console.log('.recently-viewed-slider', $('.recently-viewed-slider'))
                const recently_viewed = new Swiper('.recently-viewed-slider', {
                    slidesPerView: 'auto',
                    spaceBetween: 0,
                    scrollbar: {
                        el: '.recently-viewed-slider .swiper-scrollbar',
                        draggable: true,
                    },
                    navigation: {
                        nextEl: '.recently-viewed-swiper-buttons .swiper-button-next',
                        prevEl: '.recently-viewed-swiper-buttons .swiper-button-prev',
                    },
                    breakpoints: {
                        1024: {
                            scrollbar: false,
                            navigation: false,
                        },
                    },
                });
            }

            function calculateProductInfoHeight() {
                const dynamicHeight = window.innerHeight - HEIGHT_OFFSET;
                productInfo.css("height", `calc(40dvh + ${dynamicHeight}px)`);
            }

            function handleDragMove(e) {
                if (!isDragging || productInfo.hasClass("inner-element-scrolled")) return;

                const y = e.type === 'mousemove' ? e.pageY : e.touches[0].pageY;
                const delta = y - startY;
                const currentMarginTop = parseInt(productInfo.css('margin-top')) || 0;
                const maxUpwardMargin = -(window.innerHeight - HEIGHT_OFFSET);

                let newMargin = Math.min(Math.max(currentMarginTop + delta, maxUpwardMargin), 0);

                productInfo.css({
                    'margin-top': `${newMargin}px`,
                    'overflow-y': newMargin < 0 ? 'scroll' : '',
                    'transition': 'none'
                });

                startY = y;
            }

            // Tambahkan fungsi terpisah untuk membuka/tutup productInfo
            function toggleProductInfo(shouldOpen) {
                const maxUpwardMargin = -(window.innerHeight - HEIGHT_OFFSET);
                const finalMargin = shouldOpen ? maxUpwardMargin : 0;

                productInfo.css({
                    'margin-top': `${finalMargin}px`,
                    'transition': `${ANIMATION_DURATION}ms ease-in-out`
                });

                if (!shouldOpen) {
                    productInfo.removeClass("element-open inner-element-scrolled");
                    $('.site-header-container').removeAttr('style');
                } else {
                    productInfo.addClass("element-open");
                    $('.site-header-container').css({ 'background-color': '#FFF' });
                }

                isProductInfoOpen = shouldOpen; // Update state
            }

            function handleDragEnd(e, shouldSnapToTop = null) {
                // Jika dipanggil dari event (e adalah jQuery.Event)
                const isEventTriggered = e && (e.type === 'mouseup' || e.type === 'touchend');

                if (isEventTriggered && !isDragging) return;

                // Untuk event-triggered, set isDragging ke false
                if (isEventTriggered) {
                    isDragging = false;
                }

                const currentMarginTop = parseInt(productInfo.css('margin-top')) || 0;
                const maxUpwardMargin = -(window.innerHeight - HEIGHT_OFFSET);

                // Tentukan snap behavior
                let snapToTop;
                if (shouldSnapToTop !== null) {
                    // Gunakan parameter jika disediakan (programmatic call)
                    snapToTop = shouldSnapToTop;
                    toggleProductInfo(!snapToTop);
                } else {
                    if (productInfo.hasClass('element-open')) {
                        snapToTop = !(currentMarginTop > Math.ceil(maxUpwardMargin));
                    }
                    else {
                        snapToTop = currentMarginTop <= 0 && currentMarginTop != Math.ceil(maxUpwardMargin);
                    }
                    toggleProductInfo(snapToTop);
                }

            }

            function handleDragStart(e) {
                isDragging = true;
                startY = e.type === 'mousedown' ? e.pageY : e.touches[0].pageY;
                productInfo.css('transition', 'none');

                if (productInfo.hasClass("element-open")) {
                    const isScrolled = productInfo.scrollTop() > DRAG_THRESHOLD;
                    productInfo.toggleClass("inner-element-scrolled", isScrolled);
                }
            }

            let html = $("html");
            if (window.innerWidth > 1045) {
                $(html).removeClass('disable-scroll');
                $('.template-product .column-product-form').css('overflow-y', '');
                $('.template-product .column-product-form').css('margin-top', '');
                setProductRecentViewToSlider();

            } else {
                $(html).addClass('disable-scroll');
                $(html).scrollTop(0);

                // Inisialisasi
                setupMobileSections();
                calculateProductInfoHeight();

                // Event Listeners
                productInfo
                    .on('mousedown touchstart', handleDragStart)
                    .on('mousemove touchmove', handleDragMove)
                    .on('mouseup touchend', handleDragEnd);
            }

            $(window).on('resize', function () {
                if (window.innerWidth > 768) {
                    $('html').removeClass('disable-scroll');
                    $('.template-product .column-product-form').css('overflow-y', '');
                    $('.template-product .column-product-form').css('margin-top', '');
                } else {
                    $('html').addClass('disable-scroll');
                    $('html').scrollTop(0);

                    calculateProductInfoHeight()
                }
            });

            // swatch header run
            if (window.innerWidth <= 1024) {
                $('.swatch .header .swatch-header-run').click(function () {
                    $(this).toggleClass('active')
                })
            }
            // end swatch header run
        }

        if ($('body').hasClass('template-login')) {
            let params = new URLSearchParams(document.location.search)
            if (params.has('action')) {
                let action = params.get("action")
                if (action == 'forget-password') {
                    $('#recover-customer-password').removeClass('hidden')
                    $('#account-login').addClass('hidden')
                }
            }
        }

        function updateDays() {
            let month = parseInt($('#month').val());
            let year = parseInt($('#year').val());
            let daySelect = $("#day");

            daySelect.html('<option value="">Day</option>');

            if (!month) return;

            let daysInMonth = 31;
            if (month === 2) {
                daysInMonth = (year % 4 === 0) ? 29 : 28;
            } else if ([4, 6, 9, 11].includes(month)) {
                daysInMonth = 30;
            }

            for (let i = 1; i <= daysInMonth; i++) {
                if (i < 10) {
                    daySelect.append(`<option value="0${i}">0${i}</option>`);
                }
                else {
                    daySelect.append(`<option value="${i}">${i}</option>`);
                }
            }
        }

        $(document).on('change', '#month, #year', updateDays);

        if ($('body').hasClass('template-register')) {

            function setErrorRegister(message) {
                if ($('#create_customer').find('.errors').length == 0) {
                    $('#create_customer').prepend('<div class="errors"><ul></ul></div>')
                }
                else {
                    $('#create_customer .errors ul').empty()
                }

                $('#create_customer .errors ul').append(`<li>${message}</li>`)
                $("html, body").animate({ scrollTop: 0 }, 500)
            }

            $(document).on('click', '#btn-register-submit', function () {
                // let day = $('#day').val()
                // let month = $('#month').val()
                // let year = $('#year').val()

                const password = $('#password').val();
                const confrim = $('#confrim').val();

                // if (day == null || month == null || year == null) {
                //     setErrorRegister(`Date of birth can't be blank.`)
                //     return;
                // }

                if (password != confrim) {
                    setErrorRegister(`Passwords do not match.`)
                    return;
                }

                // let birthday = `${year}-${month}-${day}`
                // $('#birthday').val(birthday)

                $('#create_customer').submit()
            });
        }

        if ($('body').hasClass('template-account')) {
            get_customer = $('#get_personal_customer').length;

            if (get_customer) {
                let cus_id = $('#get_personal_customer').attr('data-id');
                let jsonData = {
                    id: cus_id,
                    url_shopify: 'melissaid.myshopify.com'
                }
                var url = "https://atmos-custom-plugin-front.devbdd.com/api/customers/get_data";

                $.ajax({
                    type: "POST",
                    url: url,
                    data: jsonData,
                    dataType: "json",
                    success: function (responses) {
                        // console.log('get_data', responses)
                        let notes = responses.note.split("\n");
                        notes.forEach(note => {
                            // console.log('note', note)

                            if (note.includes('phone')) {
                                let phone = note.split(" ");
                                $('#customer_phone').val(phone[1]);
                            }
                            if (note.includes('birthday')) {
                                let birthday = note.split(" ");
                                let [year, month, day] = birthday[1].split("-"); // Split YYYY-MM-DD

                                $("select[name='year']").val(year);
                                $("select[name='year']").trigger('change');
                                $("select[name='month']").val(month.padStart(2, '0'));
                                $("select[name='month']").trigger('change');
                                $("select[name='day']").val(day.padStart(2, '0')); // Ensure 2-digit format
                            }
                            if (note.includes('color')) {
                                let color = note.split(" ");
                                $('#color').val(color[1])
                            }
                            if (note.includes('favorite')) {
                                let favorite = note.split(" ");
                                $('#favorite').val(favorite[1])
                            }
                        });
                    },
                    error: function (responses) {
                        console.log(responses);
                    },
                });
            }

            $(".personal-information-form").on("submit", function (e) {
                e.preventDefault(); // Prevent page reload
                let day = $('#day').val()
                let month = $('#month').val()
                let year = $('#year').val()
                let birthday = `${day}-${month}-${year}`
                $('#birthday').val(birthday)

                // Convert form data to JSON
                var formDataArray = $(this).serializeArray();
                var jsonData = {};

                $.each(formDataArray, function () {
                    jsonData[this.name] = this.value;
                });

                // console.log("JSON Data:", jsonData); // Debugging

                $.ajax({
                    url: "https://atmos-custom-plugin-front.devbdd.com/api/customers/update_data",
                    type: "POST",
                    data: JSON.stringify(jsonData), // Send as JSON string
                    contentType: "application/json", // Tell server it's JSON
                    dataType: "json", // Expect JSON response
                    success: function (response) {
                        if (response.status === "success") {
                            // Create success label
                            $(".personal-information-form .main-button").before('<div class="success-message" style="color: green; margin-bottom: 10px;">Form submitted successfully!</div>');

                            // Wait 3 seconds and refresh
                            setTimeout(function () {
                                location.reload();
                            }, 3000);
                        }
                    },
                    error: function (xhr, status, error) {
                        alert("Submission failed! Please try again.");
                        console.error(xhr.responseText);
                    }
                });
            });
        }

        if ($('body').hasClass('template-addresses')) {
            window.location.href = '/account';
        }

        if ($('body').hasClass('template-order-details')) {
            $('html').addClass('background-cream')
            $(document).on('click', '.btn-tracking-close', function () {
                $(this).closest('.detail-summary').removeClass('active')
                $(this).closest('.detail-summary').hide()

                if (window.matchMedia("(max-width: 1024px)").matches) {
                    $('html').removeClass('disable-scroll')
                }
            })
        }

        // wishlist page
        if (window.location.href.includes('a/wishlist')) {
            $('body').addClass('template-wishlist')

            $('.wishlistpage').after('<div class="wislist-section" id="wishlist-section"></div>')
            $('#wishlist-section').load(window.location.pathname + "?section_id=wishlist-section")
            renderWishlist()
        }

        function renderWishlistEmpty() {
            let text_wishlist = "Nothing to see here…yet. Fill me up with all your heart and sole’s desires. Like. Compare. Shop. Share.";
            $('.account-page-description .description').html(text_wishlist)

            $('.account-page-button').show()
        }

        function renderWishlist() {
            $('#account-page-main').empty()

            let check_wishlist_interval = setInterval(() => {
                if ($('#account-page').length) {
                    $('#account-menu-item-wishlist').addClass('active')

                    if ($('body.template-wishlist .wishlistpage .row.products #bookmarks .empty-wishlist').length) {
                        renderWishlistEmpty()
                        clearInterval(check_wishlist_interval)
                    }
                    else if ($('body.template-wishlist .wishlistpage .row.products #bookmarks .container-fluid').length) {
                        let text_wishlist = "Your solemates await. Compare, shop, or check out when you’re ready to step out in style.";
                        $('.account-page-description .description').html(text_wishlist)
                        $('.account-page-button').hide()

                        let productHandles = [];

                        // Loop untuk mendapatkan product_handle dari elemen di halaman
                        $('.products .product').each(function (i, v) {
                            let productHandle = $(v).find('.image a').attr('href').split('?')[0];
                            if (productHandle) {
                                productHandle = productHandle.replace(/^\//, ''); // Hilangkan '/' di awal jika ada
                                productHandle = productHandle.replace('products', ''); // Hilangkan 'products' jika ada
                                productHandles.push(productHandle);
                            }
                        });

                        if (productHandles.length === 0) {
                            console.warn('No product handles found.');

                            renderWishlistEmpty()
                            clearInterval(check_wishlist_interval)
                            return;
                        }

                        // Gabungkan product_handles menjadi satu string dengan format yang sesuai untuk Shopify API
                        let productUrls = productHandles.map(handle => `/products/${handle}.json`);

                        // Gunakan Promise.all untuk mengambil semua data produk sekaligus
                        Promise.all(productUrls.map(url =>
                            $.ajax({
                                url: url,
                                type: 'GET',
                                dataType: 'json'
                            })
                        )).then(responses => {
                            $('#account-page-main').html('<div class="wishlist-page-products" id="wishlist-page-products"></div>')

                            responses.forEach(response => {
                                // console.log('Product Data:', response.product);
                                let product = response.product

                                let btn_delete = `<button class="wishlist-btn-delete removebutton singleremovebutton" data-product_image="${product.image.src}" data-productid="${product.id}" data-variantid="${product.variants[0]['id']}"><svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 16C1 17.1 1.9 18 3 18H11C12.1 18 13 17.1 13 16V4H1V16ZM14 1H10.5L9.5 0H4.5L3.5 1H0V3H14V1Z" fill="#dbdbdb"/></svg></button>`

                                let btn_atc = `
                                <button class="wishlist-btn-atc" data-productid="${product.id}" data-variantid="${product.variants[0]['id']}">
                                <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M3.24987 5.25V5.13C3.24987 3.87023 3.75032 2.66205 4.64112 1.77125C5.53191 0.88045 6.74009 0.380005 7.99987 0.380005C9.25965 0.380005 10.4678 0.88045 11.3586 1.77125C12.2494 2.66205 12.7499 3.87023 12.7499 5.13V5.25H14.2509C14.8219 5.25 15.3069 5.669 15.3909 6.234L15.6089 7.72701C16.0389 10.665 16.0389 13.651 15.6089 16.589C15.5078 17.2788 15.1797 17.9153 14.6764 18.3978C14.1731 18.8803 13.5234 19.1812 12.8299 19.253L12.2009 19.318C9.40771 19.6079 6.59204 19.6079 3.79887 19.318L3.16987 19.253C2.47638 19.1812 1.82662 18.8803 1.32332 18.3978C0.82002 17.9153 0.491911 17.2788 0.390872 16.589C-0.0391448 13.6507 -0.0391448 10.6654 0.390872 7.72701L0.609872 6.234C0.649772 5.96048 0.786856 5.71048 0.996026 5.52978C1.2052 5.34907 1.47246 5.24975 1.74887 5.25H3.24987ZM7.18987 1.983C7.66998 1.85945 8.17199 1.84736 8.65749 1.94768C9.14299 2.04799 9.5991 2.25804 9.99093 2.56175C10.3828 2.86547 10.6999 3.25479 10.9181 3.69994C11.1363 4.14509 11.2498 4.63425 11.2499 5.13V5.25H4.74987V5.13C4.74997 4.40913 4.98974 3.70874 5.43145 3.13904C5.87316 2.56934 6.49174 2.16267 7.18987 1.983ZM3.24987 6.75V9C3.24987 9.19892 3.32889 9.38968 3.46954 9.53033C3.61019 9.67099 3.80096 9.75 3.99987 9.75C4.19878 9.75 4.38955 9.67099 4.5302 9.53033C4.67085 9.38968 4.74987 9.19892 4.74987 9V6.75H11.2499V9C11.2499 9.19892 11.3289 9.38968 11.4695 9.53033C11.6102 9.67099 11.801 9.75 11.9999 9.75C12.1988 9.75 12.3896 9.67099 12.5302 9.53033C12.6709 9.38968 12.7499 9.19892 12.7499 9V6.75H13.9499L14.1249 7.94401C14.5338 10.7385 14.5338 13.5776 14.1249 16.372C14.0723 16.732 13.9011 17.0642 13.6385 17.3159C13.3759 17.5677 13.0368 17.7247 12.6749 17.762L12.0459 17.826C9.35587 18.106 6.64387 18.106 3.95387 17.826L3.32387 17.761C2.96216 17.7235 2.62329 17.5664 2.36086 17.3146C2.09843 17.0629 1.92742 16.7308 1.87487 16.371C1.46457 13.577 1.46457 10.738 1.87487 7.94401L2.04987 6.75H3.24987Z" fill="white"/>
                                </svg> Add to Bag</button>
                                `

                                let product_html = `
                                    <article class="product-list-item product-list-item-2025 wishlist-product" data-productid="${product.id}" data-variantid="${product.variants[0].id}" id="product-${product.id}">
                                        <div class="wishlist-product-wrapper">
                                            <div class="product-featured-image">
                                                <img src="${product.image.src}" alt="${product.handle}">

                                                <div class="wishlist-button-delete">
                                                    ${btn_delete}
                                                </div>

                                                <div class="wishlist-product-overlay">
                                                    ${btn_atc}
                                                </div>
                                            </div>
                                            <div class="product-text-block">
                                                <div class="product-title">${product.title}</div>
                                                <div class="product-price-badge">
                                                    <div class="product-price">
                                                        IDR ${formatRupiah(product.variants[0]['price'])}                         
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </article>
                                    `
                                $('#wishlist-page-products').append(product_html)
                            });
                        }).catch(error => {
                            console.error('Error fetching products:', error);
                        });

                        clearInterval(check_wishlist_interval)
                    }
                }
            }, 0);
        }

        $(document).on('click', '.wishlist-product', function () {
            $(this).find('.wishlist-product-overlay').addClass('active')
        })

        $(document).on('mouseleave', '.wishlist-product', function () {
            $(this).find('.wishlist-product-overlay').removeClass('active')
        })

        $(document).on('click', '.wishlist-btn-atc', function () {
            // console.log('wishlist-btn-atc clicked')
            let variant_id = $(this).attr('data-variantid')
            let this_text = $(this).html()

            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: {
                    'id': variant_id,
                    'quantity': 1
                },
                cache: false,
                dataType: 'json',
                beforeSend: function () {
                    $(this).html('<i class="fa fa-spinner fa-spin fa-fw"></i>');
                    $(this).prop('disabled', true);
                },
                success: function () {
                    renderCartHeader()
                    cartNotifShow()
                },
                complete: function () {
                    $(this).html(this_text);
                    $(this).prop('disabled', false);
                }
            })
        })

        $(document).on('click', '.wishlist-btn-delete', function () {
            $(this).closest('.product').find('.singleremovebutton.removebutton').trigger('click')
            let check_remove_modal_interval = setInterval(() => {
                if ($('#remove_modal').length) {
                    $('#remove_modal .modal-body .remove-modal-description').remove()
                    $('#remove_modal .modal-body .remove-modal-button').remove()

                    let button_close = `
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.4 14L0 12.6L5.6 7L0 1.4L1.4 0L7 5.6L12.6 0L14 1.4L8.4 7L14 12.6L12.6 14L7 8.4L1.4 14Z" fill="black"/>
                    </svg>
                    `
                    $('#remove_modal .modal-header button.close').html(button_close)

                    let append_html = `
                    <div class="remove-modal-description">
                        You'll lost this item forever.
                    </div>
                    <div class="remove-modal-button">
                        <button class="remove-button-agree">Agree</button>
                        <button class="remove-button-back">Turning Back</button>
                    </div>
                    `

                    $('#remove_modal .modal-body #remove_modal_title').html('Remove from Wishlist?')
                    $('#remove_modal .modal-body #remove_modal_title').after(append_html)
                    $('#remove_modal .modal-body').prepend($('#remove_modal .modal-header button.close'))

                    clearInterval(check_remove_modal_interval)
                }
                else {
                    $(this).closest('.product').find('.singleremovebutton.removebutton').trigger('click')
                }
            }, 0);
        })

        $(document).on('click', '.remove-button-agree', function () {
            $(this).closest('.modal-content').find('#modal_remove_button').trigger('click')
            renderWishlist()
        })

        $(document).on('click', '.remove-button-back', function () {
            $(this).closest('.modal-content').find('button[data-dismiss="modal"]').trigger('click')
        })
        // end wishlist page

        // return exchange page
        if ($('body').hasClass('template-return-exchange')) {
            $('#start-return').click(function () {
                let modal_backdrop = '<div class="modal-backdrop return_modal-backdrop fade in"></div>'
                $('#return_modal').before(modal_backdrop)
                $('#return_modal').show()
            })

            $('#return_modal .close').click(function () {
                $('.return_modal-backdrop').remove()
                $('#return_modal').hide()
            })

            $('#return_modal').click(function (e) {
                if (e.target == this) {
                    $('.return_modal-backdrop').remove()
                    $('#return_modal').hide()
                }
            })

            $('#cancel-return-modal').click(function () {
                $('.return_modal-backdrop').remove()
                $('#return_modal').hide()
            })
        }
        // end return exchange page

        // account mobile
        if (window.matchMedia("(max-width: 1024px)").matches) {
            let check_account_interval = setInterval(() => {
                if ($('#account-page').length) {
                    clearInterval(check_account_interval)
                    const params = new URLSearchParams(window.location.search)
                    const openDetail = params.get('open-detail')

                    if (openDetail != null && openDetail == 'true') {
                        $('.row-account-page').addClass('active')
                        $("body").addClass("open-detail")

                        if ($(".list-menu-help").length) {
                            $(".header-help-close").show()
                            $(".header-help-close").next().hide()
                        }
                    }

                    $(document).on('click', '#account-page .account-menu-item .account-menu-link', function (e) {
                        e.preventDefault()
                        const menuItem = $(this).closest('.account-menu-item')
                        const thisUrl = $(this).attr('href')
                        params.set('open-detail', 'true')

                        const queryString = params.toString();
                        const newUrl = `${thisUrl}${queryString ? '?' + queryString : ''}${window.location.hash}`;

                        if (menuItem.hasClass('active')) {
                            window.history.replaceState({}, '', newUrl)
                            $('.row-account-page').addClass('active')
                            $("body").addClass("open-detail")
                        }
                        else {
                            location.href = newUrl
                        }

                        if ($(".list-menu-help").length) {
                            $(".header-help-close").show()
                            $(".header-help-close").next().hide()
                        }
                    })

                    $(document).on('click', '.account-title-close', function (e) {
                        params.delete('open-detail')

                        const queryString = params.toString();
                        const newUrl = `${window.location.pathname}${queryString ? '?' + queryString : ''}${window.location.hash}`;
                        window.history.replaceState({}, '', newUrl)

                        $('.row-account-page').removeClass('active')
                    })
                }
            }, 0);
        }
        // end account mobile

        // faq page
        if (window.matchMedia("(min-width: 750px)").matches) {
            $(document).on('click', '.faq-title', function () {
                $(this)
                    .toggleClass("active")
                    .next(".faq-tab")
                    .slideToggle()
                    .parent()
                    .siblings()
                    .find(".faq-tab")
                    .slideUp()
                    .prev()
                    .removeClass("active");
            });
        }
        else {
            var current_url = location.href;
            let faq_item = '.get-help-page-main'
            if (current_url.includes("privacy-policy").length) {
                faq_item = '.consent-privacy-main'
            }

            $(document).on('click', '.faq-order-header, .faq-return-exchange-header, .consent-privacy-header', function () {
                $(this)
                    .toggleClass("active")
                    .next(`${faq_item}`)
                    .slideToggle()
                    .parent()
                    .siblings()
                    .find(`${faq_item}`)
                    .slideUp()
                    .prev()
                    .removeClass("active");
            });

            if ($(".get-help").length) {
                $(".header-help-close").click(function () {
                    current_url = new URL(window.location.href);
                    current_url.searchParams.delete('open-detail');
                    location.href = current_url
                })
            }
        }
        // end faq page

        // filter app
        $('form.filter-form.filter-dynamic').submit(function (e) {
            e.preventDefault()

            const params = new URLSearchParams(window.location.search)
            const filteredParams = new URLSearchParams();
            params.forEach((value, key) => {
                if (!key.startsWith('filter')) {
                    filteredParams.append(key, value);
                }
            });

            let filters = $(this).serializeArray()
            $.each(filters, function (i, filter) {
                filteredParams.append(filter.name, filter.value)
            })

            location.href = window.location.href.split('?')[0] + '?' + filteredParams.toString()
        })

        $(document).on('click', '.grid-view-cta', function () {
            const params = new URLSearchParams(window.location.search)
            let grid = $(this).attr('data-grid')

            params.set('product-grid', grid)
            location.href = window.location.href.split('?')[0] + '?' + params.toString()
        })
        // end filter app

        /// product list
        $(document).on('click', '.product-list-btn-atc', async function () {
            const $button = $(this);
            const originalText = $button.html();
            const productHandle = $(this).attr('data-product-handle');

            $button.html('<i class="fa fa-spinner fa-spin fa-fw"></i>');

            try {
                const product = await $.ajax({
                    url: `/products/${productHandle}.js`,
                    method: 'GET',
                    dataType: 'json'
                });

                const variant_id = await getAvailableVariantId(product.variants);

                if (!variant_id) {
                    alert('Produk tidak tersedia.');
                    return;
                }

                await $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    data: {
                        'id': variant_id,
                        'quantity': 1
                    },
                    cache: false,
                    dataType: 'json'
                });

                renderCartHeader();
                cartNotifShow();

            } catch (err) {
                console.error('Terjadi kesalahan:', err);
            } finally {
                $button.html(originalText);
            }
        })

        async function getAvailableVariantId(variants) {
            for (const variant of variants) {
                try {
                    const variantData = await $.ajax({
                        url: `/variants/${variant.id}.js`,
                        method: 'GET',
                        dataType: 'json'
                    });

                    if (variantData.inventory_quantity > 0) {
                        return variantData.id;
                    }
                } catch (err) {
                    console.error(`Gagal ambil data variant ${variant.id}:`, err);
                }
            }
            return null;
        }
        // end product list

        if ($(".about-body-slider").length) {
            const about_body_slider = new Swiper(".about-body-slider", {
                loop: true,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                freeMode: false,
                speed: 500,
                slidesPerView: 1,
                spaceBetween: 0,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                    renderBullet: function (index, className) {
                        return `
                        <div class="${className}">
                            <div class="pagination-progress"></div>
                        </div>`;
                    },
                },
                on: {
                    init: function () {
                        const bullets = document.querySelectorAll('.about-body-slider .swiper-pagination .swiper-pagination-bullet');
                        bullets.forEach(bullet => {
                            bullet.classList.remove('swiper-pagination-bullet-active');
                        });
                    }
                }
            });

            about_body_slider.on('slideChange', function () {
                $('.about-body-slider .pagination-numbers .page-number').html(`<span>${about_body_slider.realIndex + 1}</span>`)
            });
        }

        if ($(".about-body-banner-slider").length) {
            const about_body_banner_slider = new Swiper(".about-body-banner-slider", {
                loop: false,
                autoplay: false,
                freeMode: true,
                slidesPerView: 'auto',
                spaceBetween: 0
            });
        }

        $(document).on('click', '.store-item-title', function () {
            const $currentTitle = $(this);
            const $currentContent = $currentTitle.next('.store-item-content');
            const $otherTitles = $currentTitle.parent().siblings().find('.store-item-title');
            const $otherContents = $currentTitle.parent().siblings().find('.store-item-content');

            if ($currentTitle.hasClass('active')) {
                $currentTitle.removeClass('active');
                $currentContent.slideUp();
                $otherTitles.show();
            } else {
                $currentTitle.addClass('active');
                $currentContent.slideDown();
                $otherTitles.removeClass('active').hide();
                $otherContents.slideUp();
            }
        });

        $(document).on('mouseenter', '.store-city-title .title', function () {
            $('.store-city-title .title').each(function (i, v) {
                $(v).parent().removeClass('active')
            })

            let our_store_data = JSON.parse($('#out-stores-data').html())
            let handle = $(this).attr('data-handle')

            // console.log('our_store_data', our_store_data)

            $.each(our_store_data.stores, function (i, v) {
                if (v.handle == handle) {
                    $('#store-image').attr('src', v.image)
                    $('#store-title').html(v.title)
                    $('#store-description').html(v.description)
                    $('#store-button').html(v.button_text)
                    $('#store-button').attr('href', v.button_link)

                    return false;
                }
            })
            $(this).parent().addClass('active')
        })

        if ($('.store-footer-slider').length) {
            if (window.matchMedia("(max-width: 1024px)").matches) {
                const store_footer = new Swiper('.store-footer-slider', {
                    slidesPerView: 'auto',
                    spaceBetween: 32,
                    scrollbar: {
                        el: '.store-footer-slider .swiper-scrollbar',
                        draggable: true,
                    },
                });
            }
        }

        $(document).on('click', '.stores-accordion-title', function () {
            $(this)
                .toggleClass("active")
                .next(".stores-accordion-tab")
                .slideToggle()
                .parent()
                .siblings()
                .find(".stores-accordion-tab")
                .slideUp()
                .prev()
                .removeClass("active");
        });

        // $(document).on('change', 'select[name="store-title"]', function () {
        //     $('.stores-accordion-item').hide()
        //     $(`.stores-accordion-item[data-city="${$(this).val()}"]`).show()
        // })

        $('#selectToggle').click(function (e) {
            e.stopPropagation();
            $('#selectMenu').toggleClass('active');
        });

        $('.select-item').click(function () {
            var selectedText = $(this).text();
            $('#selectToggle').text(selectedText);

            $('.stores-accordion-item').hide()
            $(`.stores-accordion-item[data-city="${selectedText.toLowerCase()}"]`).show()

            $('#selectMenu').removeClass('active');
        });

        $(document).click(function (e) {
            if (!$(e.target).closest('.select-dropdown').length) {
                $('#selectMenu').removeClass('active');
            }
        });

        // product size modal
        $('#size-guide-cta').click(function () {
            let modal_backdrop = '<div class="modal-backdrop product_size_modal-backdrop fade in"></div>'
            $('#product_size_modal').before(modal_backdrop)
            $('#product_size_modal').show()
        })

        $('#product_size_modal .close').click(function () {
            $('.product_size_modal-backdrop').remove()
            $('#product_size_modal').hide()
        })

        $('#product_size_modal').click(function (e) {
            if (e.target == this) {
                $('.product_size_modal-backdrop').remove()
                $('#product_size_modal').hide()
            }
        })

        $('.tab-btn').click(function () {
            $(this).siblings('.tab-btn').removeClass('active');
            $(this).addClass('active');

            $(this).closest('.tab-size-guide').find('.tab-content > div').removeClass('active-content');
            var target = $(this).data('target');
            $(this).closest('.tab-size-guide').find('.tab-content > .tab-content-' + target).addClass('active-content');
        });
        // end product size modal

        if ($('body#challenge').length) {
            setTimeout(() => {
                document.body.scrollTop = 0; // For Safari
                document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
            }, 2000)
        }

        if ($('body').hasClass('template-special-page')) {
            $('body').removeClass('template-page')
            $('body').addClass('template-collection')


            if ($('.tb-special').children().length) {
                $('.site-header-container').addClass('header-collection-image')
            }

            setProductGrid()
        }

        // if ($('#cart-page').length) {
        //     window.location.href = "/";
        // }
    })
})(jQuery)